import { useTranslation } from 'react-i18next';
import { ChevronDown } from 'lucide-react';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const languages = [
    {
        code: 'en',
        name: 'English',
        flag: '🇺🇸'
    },
    {
        code: 'es',
        name: 'Español',
        flag: '🇪🇸'
    }
];

export default function LanguageSelector() {
    const { i18n, t } = useTranslation();
    const currentLanguage = languages.find(lang => lang.code === (i18n.resolvedLanguage || i18n.language)) || languages[0];

    const handleLanguageChange = (langCode: string) => {
        void i18n.changeLanguage(langCode);
        try {
            localStorage.setItem('i18nextLng', langCode);
        } catch { }
    };

    return (
        <DropdownMenu>
            <DropdownMenuTrigger className="inline-flex items-center gap-2 px-3 py-2 text-sm font-medium text-primary bg-transparent rounded-md hover:bg-primary/10 focus:outline-none focus:ring-2 focus:ring-primary transition-colors">
                <span className="text-lg">{currentLanguage.flag}</span>
                <span className="hidden sm:inline">{currentLanguage.name}</span>
                <ChevronDown className="w-4 h-4" />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
                {languages.map((language) => (
                    <DropdownMenuItem
                        key={language.code}
                        onClick={() => handleLanguageChange(language.code)}
                        className={`flex items-center gap-3 px-3 py-2 cursor-pointer ${currentLanguage.code === language.code
                            ? 'bg-blue-50 text-blue-700'
                            : 'hover:bg-gray-50'
                            }`}
                    >
                        <span className="text-lg">{language.flag}</span>
                        <span className="font-medium">{language.name}</span>
                        {currentLanguage.code === language.code && (
                            <span className="ml-auto text-blue-600">✓</span>
                        )}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}


